export interface DealerInfo {
	name: string;
	oems?: string[];
	state: string;
}

export const STATES = {
	CALIFORNIA: 'california',
} as const;
